/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'jquery',
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../AssetPrintAPI'

], function ($, APIFactory, DashboardPrintAPI) {

	class DashboardPrint{

		constructor() {}

		getAPI() {
			return APIFactory.createAPI(this, [DashboardPrintAPI]);
		}

		showContentsForPrint(content) {
			this.blocker = $('<div>', {
				'class': 'printBlocker'
			});
			const pageElement = content.pageElement;
			$(pageElement).append(this.blocker);
			$(pageElement).find('.tabPageHolder').css('display', 'block');
			const isTab = (content.layoutType === 'tab');
			let holdDiv = $(pageElement).find('.tabPageHolder');
			if (isTab) {
				this.originalParentMap = {};
			}
			$.each(content.modelIds, (i, modeId) => {
				const page = $(pageElement).find('#' + modeId + '_tab');
				if (!page.hasClass('selected')) {
					page.css('display', 'inline-block');
					page.css('z-index', -1);
				}
				if (isTab) {
					this.originalParentMap[modeId] = page.parent();
					holdDiv.append(page);
				}
			});
			return Promise.resolve();
		}

		hideContentsAfterPrint(modelIds, pageElement) {
			$(pageElement).find('.tabPageHolder').css('display', '');
			const isTab = !!this.originalParentMap;
			$.each(modelIds, (i, modeId) => {
				const page = $(pageElement).find('#' + modeId + '_tab');
				if (!page.hasClass('selected')) {
					page.css('display', '');
					page.css('z-index', '');
				}
				if (isTab) {
					this.originalParentMap[modeId].append(page);
				}
			});
			this.originalParentMap = null;
			if (this.blocker) {
				this.blocker.remove();
				this.blocker = null;
			}
			return Promise.resolve();
		}

		/**
		 * @description Get the minimum widget and height which can include all widgets on a page
		 * @param {Element} pageElement 
		 * @returns {Object} An object which has the following structure:
		 * {
		 *     width: 1234,
		 *     height: 4321
		 * }
		 */
		getOffScreenPageSize(pageElement) {
			var maxWidth = 0;
			var maxHeight = 0;
			var realDashboardSize = {};

			$.each($(pageElement).find('.widget'), function (i, widget) {
				var positionx = $(widget).position().left;
				var positiony = $(widget).position().top;

				if (positionx + $(widget).outerWidth() > maxWidth) {
					maxWidth = positionx + $(widget).outerWidth();
				}

				if (positiony + $(widget).outerHeight() > maxHeight) {
					maxHeight = positiony + $(widget).outerHeight();
				}
			}.bind(this));

			realDashboardSize = {
				'width': maxWidth,
				'height': maxHeight
			};

			return realDashboardSize;
		}
	}
	return DashboardPrint;
});
